import React from "react";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import IconButton from "@mui/material/IconButton";
// import InvoiceListingTable from "./InvoiceListingTable";
import Tooltip from "@mui/material/Tooltip";
// import Print from "@mui/icons-material/Print";
import printIcon from "../../../assets/Images/printIcon.svg";
import newSocietylogo from "../../../assets/Images/newSocietylogo.svg";

function MiscellaneousInvoicesPreview() {
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = React.useState({});
  const [bankDetailsData, setBankDetailsData] = React.useState([]);
  const [name, setName] = React.useState("");
  const [contact_no, setContactNo] = React.useState("");
  const [emailId, setEmailId] = React.useState("");
  const [, setIndexNumber] = React.useState(0);
  const [billTotal, setBillTotal] = React.useState(0);
  const [totalPayable, setTotalPayable] = React.useState(0);
  const [textAmt, setTxtAmt] = React.useState("");
  const [billDate, setBillDate] = React.useState("");
  const [dueDate, setDueDate] = React.useState("");
  const [notesList, setNotesList] = React.useState([]);

  const [maintenenceList, setMaintenenceList] = React.useState([]);

  const [residentId, setResidentId] = React.useState();
  const [apartmentId, setApartmentId] = React.useState();
  const [, setCCEmailId] = React.useState("");

  const [societyName, setSocietyName] = React.useState("");
  const [societyAddress, setSocietyAddress] = React.useState("");
  const { invId } = useParams();
  const [showLoader, setShowLoader] = React.useState(false);
  const [unpaidinvoiceList, setUnpaidInvoiceList] = React.useState([]);

  async function GetSocietyData() {
    let bodyFormData = {};
    await makeGetRequest(
      "society/getbyid/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        setSocietyName(response.data.data.society_name);
        setSocietyAddress(response.data.data.address);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function NotesListing() {
    let bodyFormData = {};

    makeGetRequest("notes/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          setNotesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function GetInvoicePreview(invoiceId) {
    setShowLoader(true);
    let bodyFormData = {};
    // alert(q)
    await makeGetRequest(
      "invoice/getinvoicepreviewweb/" + invoiceId,
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          setUnpaidInvoiceList(data.unpaid_invoice);
          setBankDetailsData(data.bank_details);
          setInvoiceData(data);
          setMaintenenceList(data.maintenence_json_list);
          setResidentId(data.resident_id);
          setApartmentId(data.apartment_id);
          setName(data.user_obj.first_name + " " + data.user_obj.last_name);
          setContactNo(data.user_obj.contact_no);
          setEmailId(data.user_obj.email_id);
          setBillDate(convertDate(data.invoice_date));
          setDueDate(convertDate(data.due_date));
          setBillTotal(data.total_payment);
          let calculatedTot =
            parseFloat(data.total_payment) - parseFloat(data.advance_received);
          let calculated_Total = calculatedTot.toFixed(2);
          setTotalPayable(calculated_Total);
          convertToIndianWords(calculated_Total);
          if (data.invoice_note !== "") {
            setIndexNumber(2);
          } else {
            setIndexNumber(1);
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  //   function convertToIndianWords(amount)
  // {
  //   console.log("first",amount)
  //   const units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  //   const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  //   const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  //   const scales = ['', 'thousand', 'lakh', 'crore'];

  //   function convertToWordsLessThanThousand(n) {
  //       if (n < 10) {
  //           return units[n];
  //       } else if (n < 20) {
  //           return teens[n - 11];
  //       } else if (n < 100) {
  //           return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + units[n % 10] : '');
  //       } else {
  //           return units[Math.floor(n / 100)] + ' hundred' + (n % 100 !== 0 ? ' and ' + convertToWordsLessThanThousand(n % 100) : '');
  //       }
  //   }

  //   function convertAmountToWords(amount) {
  //       let wholePart = Math.floor(amount);
  //       const decimalPart = Math.round((amount - wholePart) * 100);
  //       const wholeWords = convertToWordsLessThanThousand(wholePart);
  //       const decimalWords = decimalPart > 0 ? 'and ' + convertToWordsLessThanThousand(decimalPart) + ' paise' : '';

  //       if (wholeWords === 'zero') {
  //           return 'zero rupees only';
  //       }

  //       const words = [];
  //       let scaleIndex = 0;

  //       while (wholePart > 0) {
  //           const chunk = wholePart % 1000;
  //           if (chunk !== 0) {
  //               words.unshift(convertToWordsLessThanThousand(chunk) + ' ' + scales[scaleIndex]);
  //           }
  //           wholePart = Math.floor(wholePart / 1000);
  //           scaleIndex++;
  //       }
  // console.log("dd",words)
  //       return words.join(' ') + ' rupees ' + decimalWords +' only';
  //   }

  //   let amtnew = convertAmountToWords(amount);
  //   setTxtAmt(amtnew);

  // }

  function convertToIndianWords(amount) {
    var a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ];
    var b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    function inWords(num) {
      if ((num = num.toString()).length > 9) return "overflow";
      let n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str +=
        n[1] !== 0
          ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
          : "";
      str +=
        n[2] !== 0
          ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
          : "";
      str +=
        n[3] !== 0
          ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
          : "";
      str +=
        n[4] !== 0
          ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
          : "";
      // str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
      str +=
        n[5] !== 0
          ? (str !== "" ? "and " : "") +
            (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
            ""
          : "";
      return str;
    }

    function convertAmountToWords(amount) {
      let wholePart = Math.floor(amount);
      const decimalPart = Math.round((amount - wholePart) * 100);
      const decimalWords =
        decimalPart > 0 ? "and " + inWords(decimalPart) + "paise" : "";

      if (wholePart === 0) {
        return "zero rupees " + decimalWords + " only";
      }

      const wholeWords = inWords(wholePart);
      return wholeWords + "rupees " + decimalWords + " only";
    }

    let amtnew = convertAmountToWords(amount);
    setTxtAmt(amtnew);
  }

  function convertDate(date) {
    let arr = date.split("T");
    return arr[0];
  }

  async function sendInvoiceEmail(invoiceId) {
    let sendEmailToTenant = false;
    let isTenantOccupied = false;
    let ccEmail = "";

    await makeGetRequest(
      "resident/gettenantbyresidentandapartmentid/" +
        residentId +
        "/" +
        apartmentId
    )
      .then((response) => {
        if (response.status === 201) {
          // const data = response.data.data;
          if (response.data.data !== undefined) {
            isTenantOccupied = true;
            setCCEmailId(response.data.data.user_obj.email_id);
            ccEmail = response.data.data.user_obj.email_id;
          } else {
            isTenantOccupied = false;
            setCCEmailId("");
            ccEmail = "";
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    if (isTenantOccupied) {
      const willDelete = await swal({
        title: "This Apartment is Tenant Allocated?",
        text: "Do you want to want to send invoice email to tenant also.",
        icon: "warning",
        buttons: ["No", "Yes"],
      });

      if (willDelete) {
        sendEmailToTenant = true;
      } else {
        sendEmailToTenant = false;
      }
      console.log(sendEmailToTenant)
    }

    let societyName = localStorage.getItem("societyName");
    let societyAddress = localStorage.getItem("societyAddress");
    let name = "";
    let invoiceDate;
    let dueDate;
    let totalPayable;
    let invoiceData = "";
    await makeGetRequest("invoice/getinvoicepreviewweb/" + invoiceId)
      .then((response) => {
        invoiceData = response.data.data;
        name =
          invoiceData.user_obj.first_name +
          " " +
          invoiceData.user_obj.last_name;
        invoiceDate = moment(invoiceData.invoice_date).format("DD-MM-YYYY");
        dueDate = moment(invoiceData.due_date).format("DD-MM-YYYY");
        totalPayable = invoiceData.total_payment - invoiceData.advance_received;
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });

    let societynumber = localStorage.getItem("societyContactNo");
    let societyEmail = localStorage.getItem("societyEmail");

    let invoiceHtml4 =
      '<!doctype html><html><head><meta charset="utf-8"><title>Email</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><meta name="viewport" content="width=device-width, initial-scale=1"></head><body><div style="width: 100%; max-width: 650px; background-color: #fff; margin: 50px auto; border: 1px solid #ccc;border-radius: 10px;overflow: hidden;font-family:\'Poppins\', sans-serif; font-size: 13px;"><div style="background: #f4f3f9; text-align: center;color: #fff;   font-family:\'Poppins\', sans-serif; font-weight: 700;font-size: 28px; letter-spacing: 1px;padding: 20px;box-sizing: border-box;float: left;width: 100%;"><img src="https://suprawebservices.com/Imageskailas/newSocietyLogo.png" alt="logo" style="width: 100%; max-width: 150px;" /></div><div style=" padding: 30px 30px 0px;box-sizing: border-box;"><div style="width: 100%;float: left;text-align: center; padding-top: 25px;"><img src="https://freepngimg.com/save/64685-box-icons-symbol-computer-address-email-gmail/1600x1600" style="width: 100%; max-width: 150px;"/></div><p style="width: 100%; float: left; margin-bottom: 12px; margin-top: 10px;  font-weight: 600; color: #111111; font-size: 28px;text-align: center;">' +
      invoiceData.invoice_type +
      ' Invoice</p>    <div style=" font-weight: 400; margin-top: 0; color: #444444; font-size: 17px;text-align: center;line-height: 22px; margin-bottom: 15px;"> <b style="color: green; font-weight: 600;">' +
      societyName +
      '</b> <div style="font-size: 13px; display: block; margin-top: 10px;"><span>' +
      societyAddress +
      "</span><br><span>Phone : " +
      societynumber +
      ' </span></div></div>  <div style="font-size: 13px;color: #444444; margin: 30px 0 25px;"><div style="float: left;"><span style="display: block; color: #111111; font-size:13px; font-weight: 500;"> </span><span style="display: block;"> Invoice To : <span>' +
      name +


      




      '</span>  </span><span style="display: block;"> Invoice No : <span>' +
      invoiceData.invoice_id +
      '</span>  </span><span style="display: block;"> Invoice Date: <span>' +
      invoiceDate +
      '</span>  </span><span style="display: block;"> Due Date: <span>' +
      dueDate +



// for new changes 24-7-24
     

      '</span>  </span></div> <div style="float:right;"> <div style="text-align: right;"><span style="display: block;"> Billing Period : <span>' +
      invoiceDate +
      " to " +
      dueDate +
      '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Wing / Flat No : <span>' +
      invoiceData.uniq_apt_name +
      '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Phone : <span>' +
      contact_no +
      '</span>  </span></div><div style="text-align: right;"><span style="display: block;"> Email : <span>' +
      emailId +
       //end
      "</span> </span></div></div>";

    const arrayDataItems = maintenenceList
      .map((option, index) =>
        option.name
          ? option.name === "CGST" ||
            option.name === "SGST" ||
            option.name === "Late Fee"
            ? '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;"></td><td style="text-align: left; padding: 5px 10px;" colspan="3">' +
              option.name +
              " (" +
              option.amount +
              '%)</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
            : '<tr style="background: #ececee;"><td style="text-align: left; padding: 5px 10px;">' +
              parseInt(index + 1) +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.name +
              '</td><td style="text-align:left; padding: 5px 10px;">₹' +
              option.amount +
              '</td><td style="text-align: left; padding: 5px 10px;">' +
              option.duration +
              " " +
              option.duration_key +
              '</td><td style="text-align: right; padding: 5px 10px;">₹' +
              parseFloat(option.total).toFixed(2) +
              "</td></tr>"
          : null
      )
      .join(" ");

      let arrayunpaidList = "";

    if (unpaidinvoiceList !== null) {
      arrayunpaidList = unpaidinvoiceList
        .map(
          (optionval, index) =>
            "<tr><td>" +
            optionval.invoice_id +
            "</td><td>" +
            optionval.subject +
            "</td><td>" +
            optionval.invoice_date +
            "</td><td>" +
            optionval.due_date +
            "</td><td>₹" +
            parseFloat(optionval.total_payment).toFixed(2) +
            "</td><td>₹" +
            parseFloat(optionval.advance_received).toFixed(2) +
            "</td><td>₹" +
            parseFloat(
              optionval.total_payment - optionval.advance_received
            ).toFixed(2) +
            "</td></tr>"
        )
        .join(" ");
    }

    let invoiceHtml5 =
      '<div><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Sr.No</th><th style="text-align: left; padding: 8px 10px;">Description</th><th style="text-align: left; padding: 8px 10px;">Rate</th><th style="text-align: left; padding: 8px 10px;">Duration</th><th style="text-align: right; padding: 8px 10px; width: 60px;">Amount</th></tr></thead><tbody>' +
      arrayDataItems +
      "</tbody></table></div>";

    let invoiceHtml6 =
      '<div style="text-align: right; margin-bottom: 5px;">Advance Received<b style="width: 85px; display: inline-block">₹' +
      parseFloat(invoiceData.advance_received).toFixed(2) +
      '</b></div><div style="text-align: right; margin-bottom: 5px;">Current Invoice Total<b style="width: 85px; display: inline-block">₹' +
      parseFloat(totalPayable).toFixed(2) +
      '</b></div><div style="color: green; background-color:rgb(192, 255, 192) ; padding: 13px 20px; border-radius: 5px; font-weight: bold; text-align: center; margin: 15px 0 30px;">₹ ' +
      textAmt.toUpperCase() +
      '</div><div><p style="margin: 0 0 10px;"><b>Use Digital payment method for Payments.</b></p><p style="margin: 0 0 10px;"><b>Notes:-</b></p><ul style="  padding-left: 14px;list-style-type: decimal;">' +
      (invoiceData.invoice_note &&
        '<li style="margin: 0 0 10px;">' + invoiceData.invoice_note + "</li>") +
      notesList
        .map(
          (option, index) =>
            '<li style="margin: 0 0 10px;">' + option.notes + "</li>"
        )
        .join(" ") +
      '</ul><p style="margin: 0 0 15px;"><b>PLEASE NOTE BANK DETAILS BELOW.</b></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Account:</b></span><span>' +
      bankDetailsData.account_holder +
      '</span></p> <p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Name of Bank:</b></span><span>' +
      bankDetailsData.bank_name +
      '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">IFSC Code:</b></span><span>' +
      bankDetailsData.ifsc_code +
      '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">MICR Code:</b></span><span>' +
      bankDetailsData.micr_code +
      '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Account No.:</b></span><span>' +
      bankDetailsData.account_no +
      '</span></p><p style="margin: 0 0 10px; display: flex;"><span><b style="width: 150px; display: inline-block;">Type of Account:</b></span><span>' +
      bankDetailsData.account_type +
      '</span></p><p style="margin: 0 0 20px; display: flex;"><span><b style="width: 150px; display: inline-block;">Bank Address:</b></span><span>' +
      bankDetailsData.address +
      "</span></p>";

    let invoiceHtml7 =
      ' <p style="margin: 0 0 30px;">Please inform the online (NEFT/IMPS/UPI) / direct CHEQUE / CASH deposit details (Flat no, Transaction date, Reference no, Account holder name, Amount) by email to ' +
      societyEmail +
      '. Receipt Issue & Account Updating will be done after money transfer confirmation to society bank account.</p>'+
      (unpaidinvoiceList !== null
        ? '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div><p style="margin: 0 0 15px; padding-top: 30px; "><b>Open Invoices:</b></p><table style="width: 100%; border: 1px solid #dedaef; font-size: 13px; margin-bottom: 20px;"><thead><tr style="background: #d3cfe7;"><th style="text-align: left; padding: 8px 10px;">Invoice No.	</th><th style="text-align: left; padding: 8px 10px;">Account </th><th style="text-align: right; padding: 8px 10px; ">Invoice Date </th><th style="text-align: left; padding: 8px 10px;">Due Date	</th><th style="text-align: left; padding: 8px 10px;">Invoice Amount </th><th style="text-align: left; padding: 8px 10px;">Amount Paid </th><th style="text-align: left; padding: 8px 10px;">Amount Due</th></tr></thead><tbody>' +
          arrayunpaidList +
          '</tbody></table><div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>'
        : '<div style="border-top:1px solid #ccc;width:100%;float:left;margin:20px 0"></div>') +
      '<p style="margin: 0 0 20px;">A Simple Interest of ' +
      invoiceData.late_fee +
      '% per month will be applied against your Unit for all Payments, against Relevant Invoices, after due date.</p><p style="margin: 0 0 20px;">Note: You are receiving this email because you are the "Primary Contact" for your Unit. If you want to change the "Primary Contact" go to My Profile page and choose the desired registered user of your Unit.</p></div></div></div></body></html>';

    let bodyFormData = {
      invoiceHtml:
        invoiceHtml4 +
        "" +
        invoiceHtml5 +
        "" +
        invoiceHtml6 +
        "" +
        invoiceHtml7,
      emailId: emailId,
      subject:
        "Invoice For the Month of " +
        moment(invoiceData.invoice_date).format("MMMM"),
      ccemail: ccEmail,
    };
    await makePostRequest("invoice/sendemail", bodyFormData)
      .then((response) => {
        if (response.data.data !== undefined) {
          swal("Success", "Invoice Mail Sent Successully....", "success", {
            timer: 1000,
            buttons: false,
          });
          navigate("/InvoiceListing");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handlePrint = () => {
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;

    // window.print();

    // document.body.innerHTML = originalContents;
    // window.location.reload();

    // const printnotice = window.open(
    //   `http://localhost:3000/PrintMiscelliniousInvoice/${invId}`,
    //   "_blank"
    // );
    const printnotice = window.open(
      `https://www.resipro.in/PrintMiscelliniousInvoice/${invId}`,
      "_blank"
    );
    console.log(printnotice)
  };

  useEffect(() => {
    GetSocietyData();
    GetInvoicePreview(invId);
    NotesListing();
  }, []);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Invoice Preview</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="InvoicePreviewMain">
              <Tooltip title="Print invoice" placement="top" arrow>
                <img
                  src={printIcon}
                  className="newPrintIcon"
                  alt="printicon"
                  onClick={() => handlePrint("printableArea")}
                />
              </Tooltip>
              {/* <IconButton aria-label="download">
                                          <Print
                                            onClick={() => handlePrint('printableArea')}
                                            className="printer"
                                          />
                                        </IconButton> */}
              <div className="InvoicePreviewInnerMain" id="printableArea">
                <div className="myNewPrintHeadMain">
                  <div className="newLogOut">
                    <img src={newSocietylogo} />
                  </div>
                  <div className="societyNameAd">
                    <h2 className="invoicePreviHeading">{societyName}</h2>
                    <p className="invoicePreviSubHeading">{societyAddress}</p>
                  </div>
                </div>

                <div className="newPrintTopMain">
                  <div className="newPrintTopMainInr">
                    <div className="printTopDetLine">
                      <p>Invoice No</p>
                      <b>: {invoiceData.invoice_id}</b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Invoice Date</p>
                      <b>: {moment(billDate).format("DD/MM/YYYY")}</b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Invoice to</p>
                      <b>: {name}</b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Wing / Flat No</p>
                      <b>: {invoiceData.uniq_apt_name}</b>
                    </div>
                  </div>

                  <div className="newPrintTopMainInr">
                    <div className="printTopDetLine">
                      <p>Due Date</p>
                      <b>: {moment(dueDate).format("DD/MM/YYYY")}</b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Phone</p>
                      <b>: {contact_no}</b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Billing Period</p>
                      <b>
                        :{" "}
                        {moment(invoiceData.invoice_date).format("DD/MM/YYYY")}{" "}
                        to {moment(invoiceData.due_date).format("DD/MM/YYYY")}
                      </b>
                    </div>
                    <div className="printTopDetLine">
                      <p>Email</p>
                      <b>: {emailId}</b>
                    </div>
                  </div>
                </div>

                {/* <table className="invoiceTale">
                  <thead>
                    <tr>
                      <th>
                        <p className="invoiceHeadCont">
                          <b>Bill No : kkkkkkkk</b>
                          <span>{invoiceData.invoice_id}</span>
                        </p>
                      </th>
                      <th>
                        <p className="invoiceHeadCont">
                          <b>Bill Date :</b>

                          <span>{moment(billDate).format("DD/MM/YYYY")}</span>
                        </p>
                      </th>
                      <th>
                        <p className="invoiceHeadCont">
                          <b>Due Date :</b>
                          <span>{moment(dueDate).format("DD/MM/YYYY")}</span>
                        </p>
                      </th>
                      <th>
                        <p className="invoiceHeadCont">
                          <b>Billing Period :</b>
                          <span>
                            {moment(invoiceData.invoice_date).format(
                              "DD/MM/YYYY"
                            )}{" "}
                            to{" "}
                            {moment(invoiceData.due_date).format("DD/MM/YYYY")}
                          </span>
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p className="invoiceHeadCont">
                          <b>Bill to :</b>
                          <span>{name}</span>
                        </p>
                      </td>
                      <td>
                        <p className="invoiceHeadCont">
                          <b>Wing / Flat No :</b>
                          <span>{invoiceData.uniq_apt_name}</span>
                        </p>
                      </td>
                      <td>
                        <p className="invoiceHeadCont">
                          <b>Phone :</b>
                          <span>{contact_no}</span>
                        </p>
                      </td>
                      <td>
                        <p className="invoiceHeadCont">
                          <b>Email :</b>
                          <span>{emailId}</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table> */}

                <div className="invoiceTaleSecMain">
                  <table className="invoiceTale">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Description</th>
                        <th>Rate</th>
                        <th>Duration</th>
                        <th align="center">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {maintenenceList.map((option, index) => (
                        <>
                          {option.name !== "CGST" ||
                          option.name !== "SGST" ||
                          option.name !== "Late Fee" ? (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{option.name}</td>
                              <td align="center">
                                {option.duration_key ? (
                                  <span className="rightSpaceS">
                                    <CurrencyRupeeIcon />
                                    {parseFloat(option.amount).toFixed(2)}
                                  </span>
                                ) : (
                                  <span className="rightSpaceS">
                                    {option.amount}%
                                  </span>
                                )}

                                {option.duration_key}
                              </td>
                              <td>
                                {option.duration_key && (
                                  <>
                                    <b className="duraAmount">
                                      {option.duration}
                                    </b>
                                    {option.duration_key == "/hour" ? (
                                      <>Hours</>
                                    ) : (
                                      <>Days</>
                                    )}
                                  </>
                                )}
                              </td>
                              <td>
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(option.total).toFixed(2)}
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td></td>
                              <td>
                                {option.name}{" "}
                                <span className="persSt">
                                  ({option.amount}%)
                                </span>
                              </td>
                              <td></td>
                              <td></td>
                              <td align="center">
                                <CurrencyRupeeIcon />{" "}
                                {parseFloat(option.total).toFixed(2)}
                              </td>
                            </tr>
                          )}
                        </>
                      ))}

                      <tr>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount" align="right">
                          Current Invoice Total
                        </td>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount" align="center">
                          <CurrencyRupeeIcon />{" "}
                          {parseFloat(billTotal).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td></td>
                        <td className="ftText" align="right">
                          Advance Received
                        </td>
                        <td></td>
                        <td></td>
                        <td className="ftText" align="center">
                          <CurrencyRupeeIcon />{" "}
                          {parseFloat(invoiceData.advance_received).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount" align="right">
                          Total Payable
                        </td>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount"></td>
                        <td className="ftText highLightAmount" align="center">
                          <CurrencyRupeeIcon />{" "}
                          {parseFloat(totalPayable).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5}>
                          <p className="invoiceHeadCont invoiceHeadContNew">
                            <b>Amount in Words: </b>
                            <span className="textTrans">
                              <CurrencyRupeeIcon /> {textAmt}
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="noteMain">
                  {invoiceData.bank_details && (
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={8}>
                        <div className="bankDetailsMain">
                          <h1>Bank Details</h1>
                          <p className="bankDetailsCont">
                            <b>Name of Account :</b>
                            <span>{bankDetailsData.account_holder}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>Bank name :</b>
                            <span>{bankDetailsData.bank_name}</span>
                          </p>

                          <p className="bankDetailsCont">
                            <b>Account Number :</b>
                            <span>{bankDetailsData.account_no}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>Account type :</b>
                            <span>{bankDetailsData.account_type}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>IFSC Code :</b>
                            <span>{bankDetailsData.ifsc_code}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>MICR Code :</b>
                            <span>{bankDetailsData.micr_code}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>UPI ID :</b>
                            <span>{bankDetailsData.upi_id}</span>
                          </p>
                          <p className="bankDetailsCont">
                            <b>Bank Address :</b>
                            <span>{bankDetailsData.address}</span>
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={4} className="stambBox">
                        <div className="noteInner">
                          Secretary / Chairman / Treasurer
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <div
                      className="noteInner noteStUl"
                      style={{ borderRight: "none" }}
                    >
                      <b>Note :</b>
                      <ul>
                        {invoiceData.invoice_note != "" ? (
                          <li>{invoiceData.invoice_note}</li>
                        ) : null}
                        {notesList.map((option, index) => (
                          <li>{option.notes}</li>
                        ))}
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <Grid container>
                <Grid item xs={12} md={12} className="previewBtOuter">
                  <Button
                    className="addBt SavaeInvoiceBtn"
                    onClick={() => navigate("/InvoiceListing")}
                  >
                    {" "}
                    Cancel{" "}
                  </Button>
                  <Button
                    className="addBt PreviewBtn"
                    onClick={() => sendInvoiceEmail(invoiceData.invoice_id)}
                  >
                    {" "}
                    Save & Send Invoice
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default MiscellaneousInvoicesPreview;
